(function() {
  'use strict';

  angular
    .module('timeline', ['ksSwiper','ngAnimate', 'ngCookies', 'ngTouch',
                        'ngSanitize', 'ngMessages', 'ngAria', 'ngResource',
                        'ui.router', 'ui.bootstrap', 'angular.filter',
                        'toastr','com.2fdevs.videogular',
                        'com.2fdevs.videogular.plugins.controls',
                        'com.2fdevs.videogular.plugins.overlayplay',
                        'com.2fdevs.videogular.plugins.poster', 'angularModalService',
                        'angular-loading-bar']);
})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .directive('decades', decadesElement)
    .directive('repeatDecade', repeatDecade )


  /** @ngInject */
  function repeatDecade() {
      var directive = {
          link: linkFunc,
          controllerAs: 'md',
          controller: repeatDecadeController
      }

      return directive;

      function linkFunc(scope) {

          if(scope.$last === true) {
              scope.timeout(function(){
                  scope.$emit('LastDecade');
              })

          }
      }

      /** @ngInject */
      function repeatDecadeController($scope, $timeout) {
          $scope.timeout = $timeout
      }
  }

  /** @ngInject */
  function decadesElement($log) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/decadesElement/decades.html',
      //we are intentionally not isolating the scope here.
      //This is not a reusable component
      /*scope: {
        currentDecade: '=',
        expanded: '=',
        items: '=',
        decadelist: '=',
        updateFunc: '&'
      },*/
      link: DecadesLink,
      controller: DecadesController,
      controllerAs: 'decades',
      bindToController: true
    };



    return directive;


    function DecadesLink(scope, element, attrs, controller, transcludeFn) {
        var ae = angular.element
        //$log.debug("Linking is done!");
        controller.updateOnLink();

        scope.$on('LastDecade', function(event){
         $('.tile-slides').tilesSlider({
             random: true,
             auto: true,
             effect: 'simple',
             loop: true,
             fade: false})
        })

    }


    function getScrollBarWidth() {
      var inner = document.createElement('p');
      inner.style.width = "100%";
      inner.style.height = "200px";

      var outer = document.createElement('div');
      outer.style.position = "absolute";
      outer.style.top = "0px";
      outer.style.left = "0px";
      outer.style.visibility = "hidden";
      outer.style.width = "200px";
      outer.style.height = "150px";
      outer.style.overflow = "hidden";
      outer.appendChild(inner);

      document.body.appendChild(outer);
      var w1 = inner.offsetWidth;
      outer.style.overflow = 'scroll';
      var w2 = inner.offsetWidth;
      if (w1 == w2) w2 = outer.clientWidth;

      document.body.removeChild(outer);

      return (w1 - w2);
    }

    /** @ngInject */
    function DecadesController($log, $scope, $state, $uiViewScroll, $rootScope, $timeout, $window) {



      var vm = this;
      //the parent controller we are using;
      var main = $scope.main;

      //adjust scrollbar hiding on resize.
      angular.element(window).resize(function() {
        vm.windowSize = window.innerWidth;
        vm.setScrollbars();
        vm.setLeftOpenSize();
        $('.tile-slides').tilesSlider('resize')
      })

      vm.updateOnLink = function(){
        vm.checkForSection(main.decade,function(){
          vm.setScrollbars();
          vm.syncView();
        });
      }

      vm.checkForSection = function(d,func) {
        var dv = $('#dv-' + d);
        var pos = dv.position();
        if (pos) {
          func();
        } else {
          $timeout(vm.checkForSection, 200, true, d,func);
        }
      }

      vm.scrollerWidth=null;



      vm.setScrollbars = function(force) {
        var scrollView = $(".decade-scroller");
        var w = window.innerWidth;
        if(vm.scrollerWidth==null){
          vm.scrollerWidth = getScrollBarWidth();
        }
        var scrollerWidth = vm.scrollerWidth;
        if (main.expanded) {
          scrollView.css({ 'width': w });
          scrollView.css({ 'right': -scrollerWidth });
        } else {
          scrollView.width(w);
          scrollView.css({ 'right': "0px" });
        }
      }

      vm.setLeftOpenSize = function(){
          var percentage = $window.innerWidth >= 992 ? 80 : 100;
          if (main.expanded) {
              angular.element('.half .left').css('transform', 'translate(-' + percentage + '%, 0%)')
          }
      }

      vm.syncView = function(){
        if(main.expanded){
          vm.open(main.decade);
        } else {
          main.close();
        }
      }

      function _scrollDecade(dec, time) {
        var dv = $('#dv-' + dec);
        var dScroll = $('.decade-scroller');
        var height = dv.height();
        var npos = 0;
        npos = dv.attr('posInList') * height

        //$log.debug("Scrolling to " + npos + " * " + height);
        if(!isNaN(npos)){
          //$log.debug(npos);
          TweenLite.to(dScroll,time,{scrollTo:{y:npos},ease:Power2.easeOut});
        }
      }

      vm.scrollToBottom = function() {
          var ae = angular.element
          ae('.decade-scroller').animate({
              scrollTop: ae('#dv-1920').offset().top
          }, 1200, function(){});
      }



      vm.setViewPosition = function(d,find) {
        if(find === undefined){
          find = true;
        }
        var dv = $('#dv-' + d);
        if (dv) {
          var npos = 0;
          var dvpos = dv.position();
          if (dvpos) {
            _scrollDecade(d,0);

          } else {
            //$log.debug("starting...");
            if (find === true) {
              $timeout(vm.checkForSection, 0, true, d, function() {
                vm.setViewPosition(d,false);
              });
            }
          }

          if (main.expanded) {
            //$log.debug("decades is expanded and setting position");
            //$('#decade-scroller').css({ top: newPos });

          } else {
            //$log.debug("decades is collapsed and setting position");
            //$('#decade-scroller').css({ top: 0 });
            //$('#decade-view').scrollTop(newPos);
          }
        }
      }

        main.close = function() {
        //$log.debug("Closing");
        main.onDecadeViewClosing();
        TweenLite.to(".half .right",0.5,{x:"0%"});
        TweenLite.to(".half .left",0.5,{x:"0%",onComplete:_endClose});
        TweenLite.to(".decade-scroller",0,{right:0,delay:0.5});
      };

      function _endClose() {
        main.update({ 'decade': main.decade, 'year': '1', 'expanded': 'closed' } );
        main.onDecadeViewClosed();
        $scope.$apply();
        $('.tile-slides').tilesSlider('start')
      }

      vm.open = function(decade) {
        var percentage = $window.innerWidth >= 992 ? 80 : 100;
        main.onDecadeViewOpening(decade);
        TweenLite.to(".half .right",0.5,{x:"85.7%"}); // open to suggestions...
        TweenLite.to(".half .left",0.5,{x:"-" + percentage + "%", onComplete:_endOpen,onCompleteParams:[decade,"decade"]});
        TweenLite.to(".decade-scroller",0.5,{right:-vm.scrollerWidth});
        _scrollDecade(decade,0.5);

        $('.tile-slides').tilesSlider('stop')

      };

      function _endOpen(decade) {
        main.update({ 'decade': decade, 'year': '1', 'expanded': 'open' } );
        main.onDecadeViewOpened();
        $scope.$apply();
      }

      $scope.$watch(
        function watchCurrentDecade(scope) {
          // Return the "result" of the watch expression.
          return (main.decade);
        },
        function handleCurrentDecadeChange(newValue, oldValue) {
          vm.setViewPosition(newValue);
        }
      );
      $scope.$watch(
        function watchExpanded(scope) {
          // Return the "result" of the watch expression.
          return (scope.main.expanded);
        },
        function handleExpandedChange(newValue, oldValue) {
          vm.setScrollbars();
        }
      );

      vm.syncView();

    }

  }

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .directive('yearsNav', yearsNav)
    .directive('repeatYearsNav', repeatYearsNav)

  /** @ngInject */
  function yearsNav() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/yearsNav/yearsNav.html',

            scope: {
                items: '=',
                decade: '=',
                tag: '='
            },

            controller: YearsNavController,
            controllerAs: 'yn',
            bindToController: true
        }

        return directive;

        /** @ngInject */
        function YearsNavController($scope, filteredItemsService) {
            var yn = this
            var ae = angular.element
            var decadeStored = 0
            function callFilterService() {
                //console.log('calling filter service')
                yn.itemList = filteredItemsService.filterItems(yn.items, yn.decade, yn.tag)
            }

            $scope.$watchGroup(['yn.decade', 'yn.tag'], function(newValue){
                callFilterService()
            })

            $scope.$on('LastYearsNavItem', function(){
                var nav = ae('#years-nav')
                var docHeight = ae(window).height()
                var navHeight = nav.height()
                //console.log('yearsNav window Height: ', docHeight)
                //console.log('yearsNav Height: ', navHeight)

                var m = docHeight / 2
                var navY = m - (navHeight / 2)

                nav.css('top',navY)
            })

            callFilterService()

            $scope.$on('decadeViewClosed', function(){
                //console.log('decade view closed')
                yn.itemList = undefined
                decadeStored = yn.decade
            })

            $scope.$on('decadeViewOpening', function(e, decade){
                //console.log('yn.decade: ', yn.decade)
                //console.log('decadeStored: ', decadeStored)
                if(decade == decadeStored){
                    callFilterService()
                }
            })

            ae(window).on('scroll', function() {

                var windowHeight = ae(window).height()

                ae('.item').each(function() {
                    var itemTop = ae(this).offset().top
                    var current = ae(window).scrollTop()
                    var currentMiddle = current + windowHeight / 2
                    var itemHeight = ae(this).height()

                    if((currentMiddle > itemTop) & (currentMiddle < itemTop + itemHeight)) {
                        ae(this).find('.text').addClass('in-viewport')
                        ae('#years-nav li').removeClass("active")
                        ae('[data-yv-anchor=#' + this.id + ']').parent('li').addClass("active")
                    } else if ( current == 0 ) { // always show first year selected when scrolled to top
                        ae('#years-nav li').removeClass("active")
                        ae('#years-nav li').first().addClass("active")
                    } else if ( current == ae(document).height() - windowHeight ) {
                        ae('#years-nav li').removeClass("active")
                        ae('#years-nav li').last().addClass("active")
                    } else {
                        ae(this).find('.text').removeClass('in-viewport')
                    }
                })
            });


          yn.scrollToYear = function(year) {
              var offset = 0
              var textRow = ae('#yv-' + year.year + ' .text .row')
              // scroll so that item text ends up in middle of screen when done
              offset = (ae(window).height() - textRow.height()) / 2
              ae(window).scrollTo(textRow, 300, {offset: -offset})
          }

        }

    }

    /** @ngInject */
    function repeatYearsNav() {

        var directive = {
            link: linkFunc,
            controllerAs: 'md',
            controller: repeatYearsNavController
        }

        return directive;

        function linkFunc(scope, el, attr, controller) {
            if(scope.$last) {
                controller.last = scope.$last
                scope.$emit('LastYearsNavItem');
            }
        }

        function repeatYearsNavController() {}

    }




})();

(function() {
  'use strict';

  angular
      .module('timeline')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          items: '=',
          toggleFilter: '&',
          tagLabels: '=',
          close: '&',
          expanded: '='
      },
      controller: NavbarController,
      controllerAs: 'nv',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController() {



    }
  }

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .directive('repeatMedia', repeatMedia)
    .directive('mediaSwiper', mediaSwiper)
    .directive('videoPlayer', videoPlayer)
    .filter('trusted', trusted)

  /** @ngInject */
  function repeatMedia() {

      var directive = {
          link: linkFunc,
          controllerAs: 'md',
          controller: repeatMediaController
      }

      return directive;

      function linkFunc(scope, el, attr, controller) {
          if(scope.$last) {
              controller.last = scope.$last
              scope.$emit('LastItem');
          }
      }

      function repeatMediaController() {

      }

  }

  /** @ngInject */
  function mediaSwiper() {

      var directive = {
          templateUrl: 'app/components/item/mediaSwiper.html',
          controllerAs: 'ms',
          controller: mediaSwiperController
      }

      return directive;

      /** @ngInject */
      function mediaSwiperController($scope) {
          var ms = this
          var ae = angular.element;

          // pause video when swiped out of view
          ms.onReadySwiper = function(swiper){
              swiper.on('slideChangeStart', function () {
                  $scope.$broadcast('slideChanged');
              });
          }

          // pause video when scrolled out of view
          ae(window).on('scroll', function() {

          })
      }

  }

  /** @ngInject */
  function videoPlayer() {

      var directive = {
          templateUrl: 'app/components/item/videoPlayer.html',
          controllerAs: 'vp',
          controller: videoPlayerController,
          scope: {
              media: '='
          }
      }

      return directive

      /** @ngInject */
      function videoPlayerController($scope){
          var ae = angular.element
          var vp = this
          // access and assign video player instance
          vp.onPlayerReady = function(videoPlayer){
              vp.videoPlayer = videoPlayer
              $scope.$on('slideChanged', function(event) {
                  vp.videoPlayer.pause()
              });
          }

          vp.onUpdateState = function(state) {
              if(state == 'play'){
                  $scope.$emit('videoPlaying', vp.videoPlayer)
              }

              if(state == 'pause'){
                  $scope.$emit('videoStopped')
              }
          }

      }
  }

  /** @ngInject */
  function trusted($sce) {
       return function(url){
           return $sce.trustAsResourceUrl(url)
       }
  }

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .factory('filteredItemsService', filteredItemsService)
    .filter('tagsFilter', tagsFilter)
    .filter('webMediaFilter', webMediaFilter)


    /** @ngInject */
    function tagsFilter() {

      return function(items, filter){
          // items = [...,{'tags':[{'txtid':'a'},...],'x':'y',..},...]
          // filter.tags.txtid = ['a','b']

          // return unfiltered list of items if no params recieved
          if (typeof filter.tags.txtid === 'undefined') {
              return items
          } else if (filter.tags.txtid.length == 0) {
              return items
          } else {
              var match = false
              var result = []
              angular.forEach(items, function(i) {
                  match = false
                  angular.forEach(i.tags, function(t){
                      if(filter.tags.txtid.indexOf(t.txtid) != -1) {
                          if(!match) {
                              result.push(i)
                              match = true
                          }
                      }
                  })
              })
              return result
          }
      }
    }

    /** @ngInject */
    function webMediaFilter() {

        return function(media){
            var result = []
            angular.forEach(media, function(obj){

                if(obj.purposes.length) {
                    angular.forEach(obj.purposes, function(version){
                        if(version.txtid == 'uncropped'){
                            result.push(obj)
                        }
                    })
                } else {
                    result.push(obj)
                }

            })
            return result
        }

    }

    /** @ngInject */
    function filteredItemsService(filterFilter, orderByFilter) {

        var service = {
                filterItems: filterItems
            };

        return service;

        function filterItems(items, decade, tag){
            var filteredItems = items
            filteredItems = filterFilter(filteredItems, {date_decade: decade})
            filteredItems = tagsFilter()(filteredItems, {tags: {txtid: tag}})
            filteredItems = orderByFilter(filteredItems, '-date')

            return filteredItems
        }

    }

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .directive('itemContainer', itemContainer)

  /** @ngInject */
  function itemContainer() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/item/item.html',
      scope: {
          items: '=',
          year: '=',
          decade: '=',
          tag: '=',
          close: '&'
      },
      controller: ItemController,
      controllerAs: 'ti',
      bindToController: true,
      link: linkFunc
    };

    return directive;

    function linkFunc($scope){
        var ae = angular.element

        $scope.$on('LastItem', function(event){

            var enteredElement = undefined
            ae('.media-wrapper').on('mouseenter mouseleave', function(e){
                if(e.type == 'mouseenter') {
                    enteredElement = ae(e.currentTarget)
                    enteredElement.addClass('hover')
                }

                if(e.type == 'mouseleave') {
                    enteredElement.removeClass('hover')
                }
            })

        })
    }


    /** @ngInject */
    function ItemController($scope, filteredItemsService) {
        var ae = angular.element
        var ti = this

        ti.filteredItems = filteredItemsService.filterItems(ti.items, ti.decade, ti.tag)

        $scope.$watchGroup(['ti.decade', 'ti.tag'], function(newValue){
            ti.filteredItems = filteredItemsService.filterItems(ti.items, ti.decade, ti.tag)
        })

        $scope.$on('videoPlaying', function(event, videoPlayer) {
            ae(window).on('scroll.videoinview', function() {
                var current = ae(window).scrollTop()
                var top = videoPlayer.mediaElement.offset().top
                var height = videoPlayer.mediaElement.height()

                if(top + height < current || current < top - height) {
                    videoPlayer.pause()
                }
            })
        })

        // stop listening for scroll events related to video when paused
        $scope.$on('videoStopped', function(event) {
            ae(window).off('.videoinview')
        })

    }

  }





})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .directive('filterContainer', filterContainer);

  /** @ngInject */
  function filterContainer() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/filter/filter.html',
      scope: {
          items: '=',
          year: '=',
          tags: '=',
          showFilter: '=',
          toggleFilter: '&',
          updateTag: '&',
          expanded: '=',
          tagLabelsInUse: '='
      },
      controller: FilterController,
      controllerAs: 'fc',
      bindToController: true
    };

    return directive;



    /** @ngInject */
    function FilterController() {
        var fc = this
        //fc.years
        //var tagList = fc.tags;
        //var tagTxtids = [];
        //var i = 0;
        // for(i=0; i<tagList.length; i++ ) {
        //     tagTxtids.push(tagList[i].txtid)
        // }

        fc.txtidsInUse = []
        //fc.tagLabelsInUse = []
        var index = 0
        var label = ''

        var getTagLabel = function(txtid) {
            angular.forEach(fc.tags, function(obj){
                if(obj.txtid === txtid) {
                    label = obj.label
                }
            })
            return label
        }

        fc.setSelected = function(tag) {
            index = fc.txtidsInUse.indexOf(tag)

            if(index == -1 ) {
                fc.txtidsInUse.push(tag)

                // arbitrary limit of 3 for labels
                // if(fc.tagLabelsInUse.length < 3){
                    fc.tagLabelsInUse.push(getTagLabel(tag))
                // }

            } else {
                fc.txtidsInUse.splice(index, 1)
                fc.tagLabelsInUse.splice(index, 1)
            }
            fc.updateTag({ tag: { txtid: fc.txtidsInUse }})

        }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .directive('decadesNav', decadesNav)
    .directive('repeatDecadeNav', repeatDecadeNav);

  /** @ngInject */
  function decadesNav() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/decadesNav/decadesNav.html',

            scope: {
                decadeList: '=',
                updateFunc: '&'
            },

            controller: DecadesNavController,
            controllerAs: 'dn',
            bindToController: true
        }

        return directive;


        /** @ngInject */
        function DecadesNavController($scope, $window) {
            var dn = this
            var ae = angular.element



            ae('.decade-scroller').on('scroll', function() {
                ae('.decade-block').each(function() {
                    var offset = ae(this).offset()
                    if((offset.top > $window.innerHeight / -1.5) & (offset.top + $window.innerHeight / 1.5 < $window.innerHeight)) {
                        ae(this).find('.left').addClass('in-viewport')
                        ae('#decade-nav li').removeClass("active")
                        ae('[data-anchor=#' + this.id + ']').parent('li').addClass("active")
                    } else {
                        ae(this).find('.left').removeClass('in-viewport')
                    }
                })

          });

          dn.scrollToDecade = function(decade) {
              ae('.decade-scroller').scrollTo(ae('#dv-' + decade.decade), 300)
          }

          $scope.date = $window.moment().format('YYYY');

          // move nav to middle of window
          $scope.$on('LastDecadeNavItem', function(){
              var nav = ae('#decade-nav')
              var docHeight = ae(window).height()
              var navHeight = nav.height()

              var m = docHeight / 2
              var navY = m - navHeight / 2
              nav.css('top',navY)
          })

        }

    }

    /** @ngInject */
    function repeatDecadeNav() {

        var directive = {
            link: linkFunc,
            controllerAs: 'md',
            controller: repeatDecadeNavController
        }

        return directive;

        function linkFunc(scope, el, attr, controller) {
            if(scope.$last) {
                controller.last = scope.$last
                scope.$emit('LastDecadeNavItem');
            }
        }

        function repeatDecadeNavController() {}

    }



})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .factory('data', data);

  /** @ngInject */
  function data($log, $http, $q) {
    var apiHost = 'https://infoview.ext.net.nokia.com/public/v1/timeline';
    //var apiHost = 'http://bl-www-staging.upswell.io/srv/v1/private/timeline';
    var service = {
      apiHost: apiHost,
      getItems: getItems,
      getTags: getTags,
      getDecades: getDecades
    };

    return service;

    /** @ngInject */
    function getItems() {
        var defer = $q.defer();

        $http({
            method: 'GET',
            cache: 'true',
            url: apiHost + '/item/',
        }).success(function(response){
            defer.resolve(response)
        });

        return defer.promise;
    }

    /** @ngInject */
    function getTags() {
        var defer = $q.defer();
        $http({
            method: 'GET',
            cache: 'true',
            url: apiHost + '/tag/',
        }).success(function(response){
            defer.resolve(response)
        })

        return defer.promise;
    }

    /** @ngInject */
    function getDecades() {
        var defer = $q.defer();
        $http({
            method: 'GET',
            cache: 'true',
            url: apiHost + '/decade/',
        }).success(function(response){
            defer.resolve(response)
        })

        return defer.promise;
    }


  }
})();

(function() {
  'use strict';

angular
    .module('timeline')
    .controller('StartController', StartController);

  /** @ngInject */
  function StartController($state,$scope, $stateParams, $log, toastr ) {
    
  }
})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .controller('MainController', MainController);


  /** @ngInject */
  function MainController($document, $scope, $rootScope, $timeout, $state, $stateParams, $log, $location, toastr, items, tags, data, decade, year, decades) {
    var vm = this;
    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1457033315777;
    vm.items = items;
    vm.year = year;
    vm.decade = decade;
    vm.decades = decades;
    vm.tag = $stateParams.tag;
    vm.tagData = tags;
    vm.showFilter = false;
    vm.expanded = false;
    vm.tagLabelsInUse = []

    //call update on a stateChange.
    $rootScope.$on('$stateChangeSuccess',
      function(event, toState, toParams, fromState, fromParams) {
        if(fromState == "home"){
          vm.update(toParams);
        }
      });

    // updating tag query param when location changes
    $rootScope.$on('$locationChangeSuccess', function(event){
        vm.tag = $location.search().tag
    })


    document.addEventListener('lazybeforeunveil', function(e){
        var bg = e.target.getAttribute('data-bg');
        if(bg){
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });

    //updates controller parameters bases on an object that mirrors $StateParams.
    //It is called by the Decade View to update data without a major state change
    //and called on $stateChangeSuccess events specifically for the expanded value.
    //change = {tag:"new tag"}
    vm.update = function(change) {
      //$log.debug("CHANGE:");
      //$log.debug(change);
      if(!change.tag){
        change.tag = vm.tag;
      }
      if(!change.decade){
        change.decade = vm.decade;
      }
      if(!change.year){
        change.year = vm.year;
      }
      if(!change.expanded){
        change.expanded = vm.decade?"open":"closed";
      }

      vm.updateUrl(change);
      vm.updateExpanded(change.expanded);
      vm.tag = change.tag;
      vm.decade = change.decade;
      vm.year = change.year;
    };

    vm.updateExpanded = function(expand){
      if(expand=="open"){
        vm.expanded = true;
      } else {
        vm.expanded = false;
      }
    }

    vm.updateTag = function(tag){
      vm.tag = tag.txtid;
      // maintain open/closed status by passing current state to update
      vm.update({expanded: vm.expanded?"open":"closed"});
    }

    vm.updateUrl = function(change) {
      var url = $state.href($state.$current, change);
      //url = url.substring(1);
      //$log.debug("URL:" + url);
      $rootScope.ignoreLocationChange = true;
      location.href = url;
      return url;
    }

    vm.toggleFilter = function(){
        vm.showFilter = vm.showFilter ? false : true
    }

    vm.update($stateParams);

    vm.onDecadeViewClosing = function(){
      angular.element("#main-content").css({"z-index":"0"});
      TweenLite.to("#main-content",0.5,{opacity:"0",delay:0.0});
      TweenLite.to(".t1-content",0.5,{overflow:"hidden"});
      //TweenLite.to("#top-content",0.5,{right:-20});

    };

    vm.onDecadeViewClosed = function(){
      //$log.debug("main -- closed");
      $scope.$broadcast('decadeViewClosed')
      TweenLite.to("#main-content",0,{display:"none",opacity:"0",delay:0.0});

    };

    vm.onDecadeViewOpened = function(){

      TweenLite.to("#main-content",0,{zIndex:"6",delay:0.50});
      TweenLite.to("#main-content",1,{opacity:"1.0",delay:0.20});
    };

    vm.onDecadeViewOpening = function(decade){
      $scope.$broadcast('decadeViewOpening', decade)
      angular.element("#main-content").css({display:"block"});
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $state, $location, $rootScope, $urlRouter, $urlMatcherFactory) {
    //Aubrey 3/13/2016
    //We are using ui-routers DeferIntercept to insure that
    //these $locationChangeStart and $locationChangeSuccess handlers
    //are called before ui-router's own.


    //define the matcher once.
    var matcher = $urlMatcherFactory.compile("/:decade/:year/:expanded/");

    $rootScope.$on('$locationChangeStart', function(event) {
      //$log.debug("locationChangeStart");
    });

    //If $rootScope.ignoreLocationChange is true, only the location changes and we
    //short-ciruit the state change with event.preventDefault
    $rootScope.$on('$locationChangeSuccess', function(event, toUrl, fromUrl) {
      //$log.debug("locationChangeSuccess - ignoreLocationChange:" + $rootScope.ignoreLocationChange);
      if ($rootScope.ignoreLocationChange) {

        $rootScope.ignoreLocationChange = false;

        //find the path of the url and use it to get the parameters.
        var cut = toUrl.indexOf("#") + 1;
        var end = toUrl.indexOf("?");
        if(end == -1){
          toUrl =  toUrl.substring(cut);
        } else {
          toUrl = toUrl.substring(cut,end);
        }
        var toParams = matcher.exec(toUrl);
        //if we don't have parameters at this point its probably a bug.
        if (toParams) {
          event.preventDefault();
        } else {
          $log.error("NO MATCH between " + toUrl + " and matcher:\n" + matcher.source)
        }

      }

    });


    $rootScope.$on('$stateChangeStart', function(event) {
      //$log.debug("stateChangeStart");
    });

    $rootScope.$on('$stateChangeSuccess', function(event) {
      //$log.debug("stateChangeSuccess");
    });

    // Configures $urlRouter's listener *after* your custom listener
    $urlRouter.listen();

    $log.debug('runBlock end');


  }

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/:decade/:year/:expanded/?tag',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        resolve: {
          decade: function($stateParams) {
            return $stateParams.decade;
          },
          year: function($stateParams) {
            return $stateParams.year;
          },
          items: function(data) {
            return data.getItems();
          },
          tags: function(data) {
            return data.getTags();
          },
          decades: function(data) {
            return data.getDecades();
          }
        }

      })

    //**** DEFER INTERCEPT ****
    //Please see index.run.js and the $urlRouterProvider docs
    //as for why this is here. #DeepAngular
    // AOF 2016-03-13
    $urlRouterProvider.deferIntercept();

    //default to start.
    $urlRouterProvider.otherwise('/2010/1/closed/');
  }

})();


(function() {
  'use strict';

  angular
    .module('timeline');

})();

(function() {
  'use strict';

  angular
    .module('timeline')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("timeline").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div id=\"top-content\" class=\"container-fluid\" ng-class=\"{open: main.expanded}\"><navbar expanded=\"main.expanded\" close=\"main.close()\" toggle-filter=\"main.toggleFilter()\" tag-labels=\"main.tagLabelsInUse\"></navbar><years-nav expanded=\"main.expanded\" items=\"main.items\" decade=\"main.decade\" tag=\"main.tag\"></years-nav><filter-container tags=\"main.tagData\" items=\"main.items\" expanded=\"main.expanded\" decades=\"main.decades\" toggle-filter=\"main.toggleFilter()\" update-tag=\"main.updateTag(tag)\" show-filter=\"main.showFilter\" tag-labels-in-use=\"main.tagLabelsInUse\"></filter-container><div id=\"main-content\" class=\"tl-content\" ng-class=\"{openx: main.expanded}\"><item-container class=\"col-md-12 item-container\" id=\"items\" close=\"main.close()\" items=\"main.items\" year=\"main.year\" decade=\"main.decade\" tag=\"main.tag\"></item-container><div style=\"clear: both;\"></div></div><decades class=\"tl-decades\" items=\"main.items\" current-decade=\"main.decade\" decadelist=\"main.decades\" expanded=\"main.expanded\" update-func=\"main.update(change)\"></decades></div>");
$templateCache.put("app/components/decadesElement/decades.html","<div class=\"outer-container\"><div class=\"decade-container\" ng-class=\"{open: main.expanded}\" id=\"decade-view\"><div class=\"decade-scroller\" ng-class=\"{open: main.expanded}\"><decades-nav update-func=\"main.update(change)\" decade-list=\"main.decades\"></decades-nav><div class=\"decade-block row\" ng-repeat=\"decade in main.decades | orderBy:\'-decade\'\" id=\"dv-{{decade.decade}}\" posinlist=\"{{$index}}\" repeat-decade=\"\"><div class=\"half col-md-12\"><div class=\"col-md-offset-5 col-md-7 right\" ng-class=\"{openx: decades.expanded}\" style=\"position: relative;\"><div ng-class=\"$index == 0 ? \'first\' : \'\'\" class=\"tile-slides\" style=\"width: 100%; height: 100%;\"><img ng-src=\"{{ m.low_resolution_image }}\" ng-repeat=\"m in decade.decade_media\"></div><div class=\"scrim\"></div><div class=\"closer\" ng-if=\"main.expanded\" ng-click=\"decades.close()\"></div></div></div><div class=\"half col-md-12 hidden-xs\"><div class=\"col-md-6 col-lg-5 left in-viewport lazyload\" ng-class=\"{openx: decades.expanded}\" style=\"background-image: linear-gradient(rgba(0, 17, 53, 0.3),rgba(0, 17, 53, 0.3)), url({{ decade.decade_media[0].low_resolution_image }})\"><div style=\'class=\"closer\"\' ng-if=\"main.expanded\" ng-click=\"decades.close()\"></div><div class=\"row\"><div class=\"content col-sm-6 col-sm-pull-4 col-md-7 col-md-push-3 col-lg-7\"><h1 ng-if=\"decade.decade < 2010\">The {{ decade.decade | limitTo: 2 : 2 }}s</h1><h1 ng-if=\"decade.decade >= 2010\">Today</h1><p class=\"hidden-xs col-lg-11\" style=\"padding-left: 0;\">{{ decade.text }}</p><div><p class=\"action hidden-xs\" ng-click=\"decades.open(decade.decade)\">EXPLORE</p><p ng-if=\"decade.decade >= 2010\" ng-click=\"decades.scrollToBottom()\" class=\"action hidden-xs\">START</p></div></div></div></div></div><div class=\"half col-md-12 visible-xs\" ng-click=\"decades.open(decade.decade)\"><div class=\"left\" ng-class=\"{openx: decades.expanded}\" style=\"background-image: linear-gradient(rgba(0, 17, 53, 0.3),rgba(0, 17, 53, 0.3)), url({{ decade.decade_media[0].low_resolution_image }})\"><div style=\'class=\"closer\"\' ng-if=\"main.expanded\" ng-click=\"decades.close()\"></div><div class=\"content\"><h1 ng-if=\"decade.decade < 2010\">The {{ decade.decade | limitTo: 2 : 2 }}s</h1><h1 ng-if=\"decade.decade >= 2010\">Today</h1><div><p ng-if=\"decade.decade >= 2010\" ng-click=\"decades.scrollToBottom()\" class=\"action hidden-xs\">START</p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/decadesNav/decadesNav.html","<div id=\"decade-nav\" class=\"hidden-xs\"><ul><li ng-class=\"{active: $index==0}\" ng-repeat=\"d in dn.decadeList | orderBy:\'-decade\'\" repeat-decade-nav=\"\"><div ng-click=\"dn.scrollToDecade({decade:d.decade})\" data-anchor=\"#dv-{{d.decade}}\"></div><span class=\"century\">{{ d.decade | limitTo: 2 : 0 }}</span> <span class=\"decade\">{{ d.decade >= 2010 ? date : d.decade | limitTo: 2 : 2 }}</span></li></ul></div>");
$templateCache.put("app/components/filter/filter.html","<span class=\"filter-button\" role=\"button\" ng-class=\"{open: fc.showFilter}\" ng-click=\"fc.toggleFilter()\"></span><div class=\"col-md-12\"><div class=\"col-md-5 col-xs-12 filter\" ng-class=\"{open: fc.showFilter}\"><div class=\"col-xs-12\"><div class=\"col-md-4\"></div><div class=\"col-md-8 tag-wrapper no-padding\"><ul><li ng-click=\"fc.setSelected(t.txtid)\" ng-class=\"fc.txtidsInUse.indexOf(t.txtid) != -1 ? \'selected\' : \'\'\" ng-repeat=\"t in fc.tags\"><a ng-click=\"\" href=\"\">{{ t.label }}</a><span class=\"remove\">X</span></li></ul></div></div></div></div>");
$templateCache.put("app/components/item/item.html","<span class=\"back_to_decades\" role=\"button\" ng-click=\"ti.close()\"><</span><div ng-repeat=\"item in ti.filteredItems\" repeat-media=\"\" class=\"row-fluid row-margin item\" ng-attr-id=\"{{ \'yv-\' + item.date_year }}\" style=\"\"><div class=\"col-md-6 col-md-push-5 media-wrapper\"><media-swiper item=\"item\"></media-swiper><div class=\"ratio-container\" ng-if=\"(item.media | filter:{file_type: \'image\'} | webMediaFilter).length == 1 && (item.media|webMediaFilter).length == 1\" ng-repeat=\"m in item.media | filter:{file_type:\'image\'} | webMediaFilter\"><img class=\"img-responsive lazyload\" data-src=\"{{ m.low_resolution_hero }}\"><div ng-if=\"m.text\" class=\"caption\">{{ m.text }}</div></div><div ng-if=\"(item.media|filter:{file_type: \'video\'}|webMediaFilter).length == 1 && (item.media|webMediaFilter).length == 1\" ng-repeat=\"m in item.media | filter:{file_type:\'video\'} | webMediaFilter\"><video-player media=\"m\"></video-player></div></div><div class=\"col-md-5 col-md-pull-6 text\"><div class=\"row\"><div class=\"col-md-4\"></div><div class=\"col-md-6\"><h3>{{ item.date_year >= 2010 ? \'TODAY\' : item.date_year }}</h3><h2>{{ item.headline }}</h2><p>{{ item.text }}</p></div></div></div><div style=\"clear: both;\"></div></div>");
$templateCache.put("app/components/item/mediaSwiper.html","<ks-swiper-container id=\"item_{{ item.id }}\" ng-if=\"(item.media | webMediaFilter).length > 1\" swiper=\"swiper\" on-ready=\"ms.onReadySwiper(swiper)\" initial-slide=\"0\" loop=\"false\" show-nav-buttons=\"true\" slides-per-view=\"1\" space-between=\"0\" pagination-clickable=\"false\" pagination-is-active=\"true\"><ks-swiper-slide class=\"swiper-slide\" ng-repeat=\"m in item.media | filter:{file_type:\'video\'} | webMediaFilter\"><video-player media=\"m\"></video-player></ks-swiper-slide><ks-swiper-slide class=\"swiper-slide\" repeat-media=\"\" ng-repeat=\"m in item.media | filter:{file_type:\'image\'} | webMediaFilter\"><img class=\"img-responsive lazyload\" ng-src=\"{{ m.low_resolution_hero }}\"><div ng-if=\"m.text\" class=\"caption\">{{ m.text }}</div></ks-swiper-slide></ks-swiper-container>");
$templateCache.put("app/components/item/modal.html","<div id=\"custom-modal\"><div id=\"overlay\"><videogular vg-theme=\"bower_components/videogular-themes-default/videogular.css\"><vg-media vg-src=\"[{src: vid_src, type: \'video/mp4\'}]\"></vg-media><vg-controls><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play></videogular><a href=\"\" ng-click=\"close()\">Close</a></div><div id=\"fade\"></div></div>");
$templateCache.put("app/components/item/videoPlayer.html","<videogular vg-player-ready=\"vp.onPlayerReady($API)\" vg-update-state=\"vp.onUpdateState($state)\" vg-theme=\"bower_components/videogular-themes-default/videogular.css\"><span style=\"display: none\">{{ trusted_src = media.source|trusted }}</span><vg-media vg-src=\"[{src: trusted_src, type: \'video/mp4\'}]\"></vg-media><vg-controls vg-autohide=\"true\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-poster vg-url=\"media.poster_image\"></vg-poster></videogular>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-fixed-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"col-md-6 col-lg-5\"><div class=\"col-sm-push-1 col-md-6 col-md-push-3\"><div class=\"navbar-header\"><span class=\"back_to_decades hidden-lg hidden-md\" ng-class=\"{invisible: !nv.expanded}\" ng-click=\"nv.close()\" role=\"button\"><</span> <a href=\"/\" class=\"navbar-brand\"><img src=\"assets/images/nokia_logo.png\"></a></div></div></div><div ng-click=\"nv.toggleFilter()\" class=\"col-md-6 col-lg-7 hidden-xs hidden-sm tag-labels\"><span class=\"animate-repeat\" ng-repeat=\"t in nv.tagLabels\">{{ t }} {{ !$last ? \'&&nbsp;\' : \'\' }}</span></div></div></nav>");
$templateCache.put("app/components/yearsNav/yearsNav.html","<div id=\"years-nav\" class=\"hidden-xs\"><ul><li ng-class=\"{active: $index==0}\" ng-repeat=\"y in yn.itemList | unique:\'date_year\'\" repeat-years-nav=\"\"><div ng-click=\"yn.scrollToYear({year:y.date_year})\" data-yv-anchor=\"#yv-{{y.date_year}}\"></div><span class=\"century\">{{ y.date_year | limitTo: 2 : 0 }}</span> <span class=\"year\">{{ y.date_year | limitTo: 2 : 2 }}</span></li></ul></div>");}]);